import { useSelector } from "react-redux"

import { ReduxState } from "~/rootReducer"

const useActivePlannerPage = () =>
  useSelector((state: ReduxState) => state.activePage)

export { useActivePlannerPage }
